<template>
	<div id="menu-w" class="menu-w smenu-has-selected-link menu-activated-on-hover  menu-position-side menu-side-left menu-side-left menu-layout-compact"
	:class="(w >= 1200) ? 'sub-menu-style-over' : 'sub-menu-style-inside'">
		<div class="logo-w">
			<router-link :to="{name: 'Dashboard'}" class="logo"><img src="static/assets/img/logo.png"></router-link>
		</div>
    <div class="el-buttons-list full-width mt-4 px-4">
      <a v-on:click="discover()" class="btn btn-outline-primary btn-sm" href="#">
        <i class="os-icon os-icon-robot-2"></i><span>{{ t.discover }}</span>
      </a>
    </div>
		<dock/>
		<onlineUsers />
	</div>
</template>

<script>
    import Dock from './dock'
    import ProfilePic from '@/components/user/ProfilePic'
    import onlineUsers from '@/components/user/widget/online'
    import VueSticky from 'vue-sticky'

    export default {
        components: { Dock, ProfilePic, onlineUsers },
        directives: {
            'sticky': VueSticky,
        },
        name: 'navigation',
        data () {
            return {
              t: this.$root.t,
              blurred: true,
	            w: window.innerWidth
            }
        },
        mounted() {
            setTimeout(() => {

            }, 500)
        },
        methods: {
            discover () {
                this.showHints();
                this.showInfo();
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Navigation.vue